import React from 'react';
import { ReactComponent as EmailIcon } from './../../../assets/icons/email-simple.svg';
import './email.css';

export const Email = ({email = '', weight = ''}) => {
    return <a className='email-link' href={'mailto:' + email} title={`Send an email to ${email}`}>
        <EmailIcon className={weight} />
        {email}
    </a>
}